import { render, staticRenderFns } from "./plateTitle.vue?vue&type=template&id=73d85d28&scoped=true&"
import script from "./plateTitle.vue?vue&type=script&lang=js&"
export * from "./plateTitle.vue?vue&type=script&lang=js&"
import style0 from "./plateTitle.vue?vue&type=style&index=0&id=73d85d28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d85d28",
  null
  
)

export default component.exports